import { render, staticRenderFns } from "./BoardSkeleton.vue?vue&type=template&id=1d5bab8c&"
import script from "./BoardSkeleton.vue?vue&type=script&lang=js&"
export * from "./BoardSkeleton.vue?vue&type=script&lang=js&"
import style0 from "../less/boardSkeleton.less?vue&type=style&index=0&lang=less&module=%24&"

var cssModules = {}
var disposed = false

function injectStyles (context) {
  if (disposed) return
  
        cssModules["$"] = (style0.locals || style0)
        Object.defineProperty(this, "$", {
          configurable: true,
          get: function () {
            return cssModules["$"]
          }
        })
      
}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })



        module.hot && module.hot.accept(["../less/boardSkeleton.less?vue&type=style&index=0&lang=less&module=%24&"], function () {
          var oldLocals = cssModules["$"]
          if (oldLocals) {
            var newLocals = require("../less/boardSkeleton.less?vue&type=style&index=0&lang=less&module=%24&")
            if (JSON.stringify(newLocals) !== JSON.stringify(oldLocals)) {
              cssModules["$"] = newLocals
              require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js").rerender("1d5bab8c")
            }
          }
        })

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d5bab8c')) {
      api.createRecord('1d5bab8c', component.options)
    } else {
      api.reload('1d5bab8c', component.options)
    }
    module.hot.accept("./BoardSkeleton.vue?vue&type=template&id=1d5bab8c&", function () {
      api.rerender('1d5bab8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/board/components/BoardSkeleton.vue"
export default component.exports